import type { ReactNode } from 'react'
import './componentes.css'

type Tom = 'info' | 'sucesso' | 'alerta' | 'perigo'

/** Símbolo por tom — UI-09: a cor não carrega a informação sozinha. */
const SIMBOLO: Record<Tom, string> = {
  info: 'i',
  sucesso: '✓',
  alerta: '!',
  perigo: '×',
}

export function Aviso({
  tom = 'info',
  titulo,
  children,
}: {
  tom?: Tom
  titulo?: string
  children: ReactNode
}) {
  return (
    <div
      className={`aviso aviso--${tom}`}
      role={tom === 'perigo' ? 'alert' : 'status'}
    >
      <span className="aviso__simbolo" aria-hidden="true">
        {SIMBOLO[tom]}
      </span>
      <div>
        {titulo && <strong className="aviso__titulo">{titulo}</strong>}
        <div className="aviso__corpo">{children}</div>
      </div>
    </div>
  )
}
